@if (data.resultats) {
<table data-tfa="recup-formations-porteuses-erreurs-table" mat-table class="table-container" [dataSource]="data.resultats!" tabindex="0">
    <!-- CODE -->
    <ng-container matColumnDef="codeFormationPorteuseDeCharge" role="row">
        <th
            tabindex="0"
            mat-header-cell
            *matHeaderCellDef
            scope="col"
            role="columnheader"
            data-tfa="header-cell_codeFormationPorteuseDeCharge"
        >
            Formation porteuse de charge
        </th>
        <td
            tabindex="0"
            mat-cell
            *matCellDef="let element; let i = dataIndex"
            role="cell"
            class="action codeFormationPorteuseDeCharge"
            [attr.data-tfa]="'codeFormationPorteuseDeCharge-' + element.codeFormationPorteuseDeCharge"
        >
            {{ element.codeFormationPorteuseDeCharge }}
        </td>
    </ng-container>
    <ng-container matColumnDef="succes" role="row">
        <th tabindex="0" mat-header-cell *matHeaderCellDef scope="col" role="columnheader" data-tfa="header-cell_succes">Résultat</th>
        <td
            tabindex="0"
            mat-cell
            *matCellDef="let element; let i = dataIndex"
            role="cell"
            class="action succes"
            [attr.data-tfa]="'succes-' + element.codeFormationPorteuseDeCharge"
        >
            <mat-icon
                data-tfa="icon-resultat"
                aria-hidden="false"
                [attr.aria-label]="element.succes ? 'succès' : 'erreur'"
                [style.color]="element.succes ? 'green' : 'red'"
                >{{ element.succes ? 'check' : 'close' }}</mat-icon
            >
        </td>
    </ng-container>
    <ng-container matColumnDef="nombreObjets" role="row">
        <th tabindex="0" mat-header-cell *matHeaderCellDef scope="col" role="columnheader" data-tfa="header-cell_type">Objets concernés</th>
        <td
            tabindex="0"
            mat-cell
            *matCellDef="let element; let i = dataIndex"
            role="cell"
            class="action nombreObjets"
            [attr.data-tfa]="'nombreObjets-' + element.codeFormationPorteuseDeCharge"
            style="text-align: end;"
        >
            @if (element.objetsConcernes.length === 1) {
            <div class="code-container">{{ element.objetsConcernes[0].codeObjet }}</div>
            } @else {
            <div class="code-container">{{ element.objetsConcernes.length }} objets concernés</div>
            }
        </td>
    </ng-container>
    <ng-container matColumnDef="message" role="row">
        <th tabindex="0" mat-header-cell *matHeaderCellDef scope="col" role="columnheader" data-tfa="header-cell_message">Message</th>
        <td
            tabindex="0"
            mat-cell
            *matCellDef="let element; let i = dataIndex"
            role="cell"
            class="action message"
            [attr.data-tfa]="'message-' + element.codeFormationPorteuseDeCharge"
        >
            @if (element.objetsConcernes.length === 1) {
            {{ element.objetsConcernes[0].message }}
            } @else { }
        </td>
    </ng-container>
    <ng-container matColumnDef="expand" role="row">
        <th
            tabindex="0"
            mat-header-cell
            *matHeaderCellDef
            scope="col"
            role="columnheader"
            data-tfa="header-cell_expand"
            aria-label="ouvrir les détails de la ligne"
        >
            &nbsp;
        </th>
        <td
            tabindex="0"
            mat-cell
            *matCellDef="let element; let i = dataIndex"
            role="cell"
            class="action expand"
            [attr.data-tfa]="'expand-' + element.codeFormationPorteuseDeCharge"
        >
            @if (isMultipleRow(i, element)) {
            <button
                mat-icon-button
                data-tfa="bouton-etendre-ligne"
                class="toggle-button"
                [class.toggle-button-expanded]="isExpandedRow(element)"
                (click)="toggleRowExpansion(element)"
                [matTooltip]="isExpandedRow(element) ? 'Replier les détails' : 'Afficher les détails'"
            >
                <mat-icon data-tfa="icon-expand">keyboard_arrow_down</mat-icon>
            </button>
            }
        </td>
    </ng-container>
    <!-- EXPANDED CONTEXTS COLUMN -->
    <ng-container matColumnDef="detailsObjets">
        <td
            tabindex="0"
            mat-cell
            *matCellDef="let element; let i = dataIndex"
            class="expanded-detail"
            [attr.data-tfa]="'cell-expanded-contexts-' + element.code"
        >
            @if (!isExpandedRow(element)) {
            {{ element.objetsConcernes.length }} objets concernés } @else {
            <div class="details-container" [@detailExpand]>
                @for (objet of element.objetsConcernes; track $index) {
                <div class="individual-error" [class.expanded]="isExpandedRow(element)">{{ objet.codeObjet }}</div>
                }
            </div>
            }
        </td>
    </ng-container>
    <ng-container matColumnDef="detailsMessages" role="row">
        <td
            tabindex="0"
            mat-cell
            *matCellDef="let element; let i = dataIndex"
            role="cell"
            class="expanded-detail detailsMessages"
            [class.expanded]="isExpandedRow(element)"
            [attr.data-tfa]="'detailsMessages-' + element.codeFormationPorteuseDeCharge"
        >
            @if (isExpandedRow(element)) {
            <div class="details-container" [@detailExpand]>
                @for (objet of element.objetsConcernes; track $index) {
                <div class="individual-message" [class.expanded]="isExpandedRow(element)">{{ objet.message }}</div>
                }
            </div>
            }
        </td>
    </ng-container>
    <tr
        mat-row
        *matRowDef="
            let element;
            let index = dataIndex;
            columns: ['codeFormationPorteuseDeCharge', 'succes', 'nombreObjets', 'message', 'expand'];
            when: !isMultipleRow
        "
        [ngClass]="{ 'grey-row': index % 2 !== 0 }"
        data-tfa="normal-row"
    ></tr>
    <!-- expandable row -->
    <tr
        mat-row
        *matRowDef="
            let element;
            let index = dataIndex;
            columns: ['codeFormationPorteuseDeCharge', 'succes', 'detailsObjets', 'detailsMessages', 'expand'];
            when: isMultipleRow
        "
        class="expansion-row"
        [class.expanded]="isExpandedRow(element)"
        [ngClass]="{ 'grey-row': index % 2 !== 0 }"
        data-tfa="expandable-row"
    ></tr>
    <tr
        mat-header-row
        *matHeaderRowDef="['codeFormationPorteuseDeCharge', 'succes', 'nombreObjets', 'message', 'expand']"
        data-tfa="header-row"
    ></tr>
</table>

}

<mat-card-actions>
    <button data-tfa="télécharger-résultats-button" mat-raised-button color="accent" mat-dialog-close="true">
        <mat-icon data-tfa="icon-download">download</mat-icon>
        Télécharger sous forme de fichier
    </button>
</mat-card-actions>
